/**
 * Browser half of chunked AES-256-GCM for encrypted-message attachments
 * (format v2). Part n (1-based) is encrypted under IV = ivPrefix (8 bytes) ‖
 * uint32BE(n) and stored as ciphertext ‖ 16-byte tag. The server decrypts with
 * backend/src/modules/secrets/chunked-cipher.ts — keep the two in step.
 */

export function base64ToBytes(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

/** Import the one-time data key the server issued (non-extractable, encrypt only). */
export function importChunkKey(base64Key) {
  return crypto.subtle.importKey('raw', base64ToBytes(base64Key), 'AES-GCM', false, ['encrypt']);
}

function partIv(ivPrefix, partNumber) {
  const iv = new Uint8Array(12);
  iv.set(ivPrefix.subarray(0, 8));
  new DataView(iv.buffer).setUint32(8, partNumber);
  return iv;
}

/** Encrypt one part; WebCrypto appends the 16-byte GCM tag. */
export async function encryptPart(key, ivPrefix, partNumber, plaintext) {
  const ciphertext = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv: partIv(ivPrefix, partNumber) },
    key,
    plaintext,
  );
  return new Uint8Array(ciphertext);
}
